import script from "./SimilarAnalysesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimilarAnalysesList.vue?vue&type=script&setup=true&lang=ts"

import "./SimilarAnalysesList.vue?vue&type=style&index=0&id=7fb2162c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb2162c"]])

export default __exports__